import { Trans } from '@lingui/react/macro';

import Button from '@/design_system/Button';
import Paragraph from '@/design_system/Typography/Paragraph';
import Title from '@/design_system/Typography/Title';
import { useDeleteCurrentSession } from '@/models/user';

const NoOrganizations = () => {
  const {
    mutateAsync: deleteCurrentSession,
    isPending: isDeletingCurrentSession,
    isSuccess: hasDeletedCurrentSession,
  } = useDeleteCurrentSession();

  return (
    <>
      <Title size="200" as="h1" align="center">
        <Trans id="no-organizations.title">You are not part of any organization</Trans>
      </Title>
      <Paragraph align="center">
        <Trans id="no-organizations.subtitle">
          Please contact your organization administrator to be added to the organization.
        </Trans>
      </Paragraph>
      <div style={{ textAlign: 'right' }}>
        <Button
          type="button"
          variant="secondary"
          isLoading={isDeletingCurrentSession}
          disabled={hasDeletedCurrentSession}
          onPress={() => {
            deleteCurrentSession();
          }}
        >
          <Trans id="no-organizations.logout">Logout</Trans>
        </Button>
      </div>
    </>
  );
};

export default NoOrganizations;
